import { cn } from '@/_lib/utils'

/**
 * Shared Tailwind class string for quick slot pills and mobile calendar slot buttons.
 *
 * @remarks Used by {@link AProductTemplateCalendarQuickRow} and mobile slot grids for visual parity.
 */
export const templateCalendarQuickSlotButtonClass = cn(
	'flex items-center gap-1',
	'px-3 py-2 rounded-full',
	'text-xs font-medium text-white md:text-sm',
	'bg-medante-pink-secondary hover:bg-medante-pink-secondary/80 transition-colors duration-200 cursor-pointer'
)
